// Acesso à área de Relatórios liberado por EMAIL (não por role/permissão).
// A lista de emails vem do .env do frontend: VITE_REPORTS_ALLOWED_EMAILS
// (separados por vírgula). Mantenha-a igual ao REPORTS_ALLOWED_EMAILS do backend.

export const getAllowedReportEmails = () =>
  (import.meta.env.VITE_REPORTS_ALLOWED_EMAILS || "")
    .split(",")
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean)

// Extrai o email do userData (login salva obj.profile como userData)
const resolveEmail = (user) => {
  const data =
    user || JSON.parse(localStorage.getItem("userData") || "null") || {}
  return (data.email || data?.dataGeneral?.email || "").toLowerCase()
}

export const canAccessReports = (user) => {
  const email = resolveEmail(user)
  if (!email) return false
  return getAllowedReportEmails().includes(email)
}
